<script setup>
import SectionHeading from '@/components/ui/SectionHeading.vue'

/**
 * Klientské reference. POZOR: níže uvedené texty jsou PLACEHOLDERY podle
 * návrhu — reálné reference doplní klient (Kristýna / Adam / kontakty).
 */
const references = [
    {
        quote: 'S účetními službami jsme velmi spokojeni. Účetní firma nám vychází vstříc při řešení problémů, uzávěrky odvádějí včas a poskytují maximální součinnost při kontrolách účetnictví. Spolupráce si velice vážíme.',
        name: 'Marek Pekař',
        company: 'L5BET CZ, s.r.o.',
    },
    {
        quote: 'Šetří mi čas i stres a jsou velice ochotní. Komunikaci hodnotím kladně, protože vše je vyřešeno vždy v řádu hodin, a mnohdy i mimo pracovní dobu. Mohu jen doporučit.',
        name: 'J. M. Ječková',
        company: 'UNICHEERS s.r.o.',
    },
    {
        quote: 'Jejich schopnost vysvětlit mi daňové záležitosti a účetní procesy tak, abych je snadno chápal, je opravdu vynikající. Cenné rady a doporučení mi vždy hodně pomohly.',
        name: 'Jakub Babica',
        company: 'Three Production s.r.o.',
    },
]
</script>

<template>
    <section
        class="bg-white py-24 md:py-32"
        id="reference"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <div class="mx-auto max-w-2xl text-center">
                <SectionHeading
                    eyebrow="Reference"
                    title="Co o nás říkají naši klienti?"
                />
            </div>

            <div class="mt-16 grid gap-6 md:grid-cols-3 md:gap-8">
                <figure
                    class="flex flex-col rounded-2xl bg-zinc-100/70 p-8 md:p-10"
                    v-for="reference in references"
                    :key="reference.name"
                >
                    <span
                        class="text-brand-200 font-serif text-6xl leading-none"
                        aria-hidden="true"
                    >
                        &bdquo;
                    </span>

                    <blockquote class="mt-4 text-base leading-relaxed text-zinc-700">
                        {{ reference.quote }}
                    </blockquote>

                    <figcaption class="mt-8">
                        <p class="text-brand-900 font-bold">{{ reference.name }}</p>
                        <p class="mt-0.5 text-sm text-zinc-500">{{ reference.company }}</p>
                    </figcaption>
                </figure>
            </div>
        </div>
    </section>
</template>
